module.exports = __webpack_public_path__ + "img/detail-bg.7038188b.png";